export default class UrlParameter {
  public static isQueryChanged(route: any, query: {
    [key: string]: string | Array<string | null> | null | undefined;
  }): boolean {
    return !Object.keys(query).every(
      (key: string) => query[key]?.toString() === route.query[key],
    );
  }
}
